export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10
    }
  },
  methods: {
    handlePageChange(page) {
      this.page = page
      this.loadList()
    },
    handleSearch() {
      this.page = 1
      this.loadList()
    },
    async loadList() {
      if (typeof this.fetchList !== 'function') return
      this.loading = true
      try {
        const result = await this.fetchList({
          page: this.page,
          size: this.pageSize
        })
        this.list = result.list || result.records || []
        this.total = result.total || 0
      } catch (e) {
        // 错误由 request 拦截器统一弹框
      } finally {
        this.loading = false
      }
    }
  }
}
